import { render, staticRenderFns } from "./AccountHolderAuthorizedSigners.vue?vue&type=template&id=53f61ebf&scoped=true"
import script from "./AccountHolderAuthorizedSigners.vue?vue&type=script&lang=ts"
export * from "./AccountHolderAuthorizedSigners.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderAuthorizedSigners.vue?vue&type=style&index=0&id=53f61ebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f61ebf",
  null
  
)

export default component.exports